export const locale = {
  lang: 'vn',
  data: {
    PANEL_TITLE: 'Kết quả đối chiếu',
    TICKET_STATUS: {
      PENDING: 'Chưa xử lý',
      WAITING_APPROVAL: 'Chờ duyệt',
      REQUEST_MODIFICATION: 'Yêu cầu điều chỉnh',
      COMPLETED: 'Đã xử lý',
    },
    RECONCILE_STATUS: {
      RECONCILED: 'Đã đối soát',
      TO_BE_RECONCILE: 'Cần đối soát',
      ORDER_NOT_FOUND: 'Không có đơn hàng',
      TX_NOT_FOUND: 'Không có thanh toán',
    },
    SUMMARY_INFO: {
      CUSTOMER_INFO: 'Thông tin khách hàng',
      ORDER_INFO: 'Thông tin đơn hàng',
      TRANSACTION_INFO: 'Thông tin thanh toán',
      CONTACT: 'Thông tin liên hệ',
      SHIPPING_ADDRESS: 'Địa chỉ giao hàng',
      EMAIL_FOR_CHECKOUT: 'Email thanh toán',
      TRANSACTION_ID: 'Mã giao dịch',
      ORDER_ID: 'Mã đơn hàng',
      ORDER_DATE: 'Ngày đặt hàng',
      ITEM: 'Tên hàng',
      SKU: 'SKU',
      BUNDLE_NAME: "Bundle",
      GIFT: "Gift",
      REFERENCE_TXN_ID: 'Mã tham chiếu',
      EXTERNAL_REFERENCE_NO: 'Mã tham chiếu nội bộ',
      DATE: 'Ngày thanh toán',
      TYPE: 'Loại giao dịch',
      PAYMENT_METHOD: 'Phương thức thanh toán',
      PAYMENT_METHOD_TYPE: {
        PAYPAL: 'PayPal Checkout',
        TWOCHECKOUT: '2Checkout',
        ONEPAY_CREDIT: 'Onepay credit',
        ONEPAY_ATM: 'Onepay ATM',
        ONEPAY_QR: 'Onepay - QR Payment',
        ONEPAY_QR_REFUND: 'Onepay QR Refund',
        ONEPAY_VIETQR: 'Onepay - VietQR',
        ONEPAY_VIETQR_REFUND: 'Onepay VietQR Refund',
        ONEPAY_MP: 'Onepay - Merchant Portal (MP)',
        PAYPAL_HK: 'PayPal Hong Kong',
        STRIPE: 'Stripe'
      },
    },
    RECONCILIATION_RESULTS: {
      TITLE: 'Đối chiếu',
      ORDER_SUMMARY: 'Đơn hàng',
      TOTAL_PAYMENT: 'Tổng tiền',
      SHIPPING_COST: 'Phí vận chuyển',
      DISCOUNT: 'Giảm giá',
      TOTAL_PAID: 'Đã thanh toán',
      INVOICE_SUMMARY: 'Hoá đơn',
      AMOUNT: 'Số tiền',
    },
    WORKING_HISTORY: {
      TITLE: 'Lịch sử đối soát',
      TIME: 'Thời gian',
      CONTENT: 'Nội dung',
    },
    DUPLICATE_ORDER_CONFIRMATION: {
      CONFIRM_HEADER: 'Lưu trữ đơn hàng trùng lặp',
      CONFIRM_MESSAGE:
        'Đơn hàng sẽ được lưu trữ và chuyển sang trạng thái <b>Hủy</b> sau khi phê duyệt. <br/><br/>Thao tác này không thể khôi phục',
      CLOSE_BUTTON_TEXT: 'KHÔNG',
      ACCEPT_BUTTON_TEXT: 'ĐỒNG Ý',
    },
    CONFIRMATION: {
      TITLE: 'Xác nhận lý do',
      SELECT_LABEL: 'Chọn lý do chênh lệch',
      DESCRIPTION: 'Diễn giải',
      REFERENCE_TXN_ID: 'Mã tham chiếu',
      CONFIRM: 'Xác nhận',
      REQUEST_MODIFICATION: 'Yêu cầu điều chỉnh',
      APPROVE: 'Duyệt',
      REASON: {
        DIFFERENCE_QUANTITY: 'Chênh lệch số lượng',
        DIFFERENCE_COUPON_DISCOUNT: 'Chênh lệch do mã coupon/discount',
        GIFT_ORDER: 'Đơn hàng quà tặng',
        DUPLICATE_ORDER: 'Đơn hàng trùng lặp',
        PAY_ANOTHER_METHOD: 'KH thanh toán bằng hình thức khác',
        NO_ORDER: 'Chưa tạo đơn hàng',
        NO_PAYMENT: 'Thanh toán phi thương mại',
        REFUNDING_ORDER: 'Hoàn tiền cho đơn hàng',
        ADDITIONAL_PAYMENT: 'Thanh toán bổ sung',
        OTHERS: 'Khác',
      },
      ERROR: {
        REQUIRED: 'Vui lòng nhập thông tin',
      },
    },
    COMMENT: {
      TITLE: 'Bình luận',
      PLACEHOLDER: 'Bình luận',
      NOTE: 'Tối đa 400 kí tự',
      ICON_EMOJI: 'Chèn Emoji',
      ICON_ATTACH: 'Đính kèm tệp',
      ICON_SEND: 'Gửi',
    },
    DIALOG: {
      CONFIRM_HEADER: 'Xác nhận thành công!',
      CONFIRM_MESSAGE: 'Data được xác nhận thành công sẽ được chuyển tới Quản lý của bạn',
      CLOSE_BUTTON_TEXT: 'ĐÓNG',
      APPROVAL_SUCCESS: 'Duyệt thành công!',
      APPROVAL_SUCCESS_MSG: 'Mã đối soát <strong>{{ticketId}}</strong> đã được duyệt thành công.',
      REQUEST_SUCCESS: 'Đã gửi yêu cầu chỉnh sửa',
      REQUEST_SUCCESS_MSG: 'Mã đối soát <strong>{{ticketId}}</strong> đã được gửi về cho người đối soát với trạng thái Yêu cầu điều chỉnh.',
    },
    COPPIED: 'Đã sao chép'
  },
};
